<stx-generic-wide-page>
  <stx-report-header>
    {{ 'treatment.orthognathic_treatment' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>
  @if (reportService.initialized$ | async) {
  <stx-orthognathic-treatment-report-table></stx-orthognathic-treatment-report-table>
  }
</stx-generic-wide-page>
